import type { Ref } from 'vue'
import { unref, computed } from 'vue'
import type { FormSelectOption, FormSelectValue } from '@/interfaces'

export function useFormSelect(modelValue: Ref<FormSelectValue>, options: Ref<FormSelectOption[]>, searchQuery: Ref<string>, isMultiple: boolean) {

    const values = computed(() => Array.isArray(modelValue.value) ? modelValue.value : [modelValue.value].filter(val => val !== null));

    const available = computed(() => {
        const search = unref(searchQuery)?.trim().toLowerCase();

        return unref(options)
            .filter(option => !("value" in option) || (!search || option.label.toLowerCase().includes(search)))
            .filter(option => !("value" in option) || !isMultiple || !unref(selected).find(selected => selected.value === option.value));
    });

    const selected = computed(() => unref(values)
        .map(val => unref(options).find(option => isSelectOption(option) && option.value === val))
        .filter(isSelectOption));

    function isSelectOption(item: unknown): item is FormSelectOption {
        return item !== null && typeof item === "object" && "value" in item;
    }

    return {
        values,
        available,
        selected
    };
}